module.exports = __webpack_public_path__ + "img/DealerIcons-M1-Off.868546a.jpg";